class Requests {
    constructor() {
        this.init();
    }

    init = () => {
        new HandleForm("#new_demo_request");
        new HandleForm("#new_partner_request");
        new HandleForm("#new_contact_request");
    };
}

class HandleForm {
    element = null;

    constructor(formId) {
        this.element = document.querySelector(formId);
        if (!this.element) return;
        this.element.addEventListener("ajax:success", (event) => {
            const [_data, _status, xhr] = event.detail;
            this.element.classList.add("hidden");
            this.element.insertAdjacentHTML("afterend", xhr.responseText);
            this.onSuccess(formId);
        });
        this.element.addEventListener("ajax:error", (event) => {
            const [_data, _status, xhr] = event.detail;
            this.element.insertAdjacentHTML("afterend", xhr.responseText);
        });
    }

    onSuccess = (formId) => {
        let eventName = "";
        switch (formId) {
            default:
                break;
            case "#new_contact_request":
                eventName = "contact_form_sent";
                break;
            case "#new_demo_request":
                eventName = "register_for_demo_sent";
                break;
            case "#new_partner_request":
                eventName = "new_partner_request";
                break;
        }
        if (dataLayer && eventName) {
            dataLayer.push({ event: eventName });
        }
    };
}

export default Requests;
